import { updateAppActiveStep } from '../../../redux/appBuilder/stepperDetails';
import { useAppDispatch } from '../../../redux/hooks';
import { SelectData } from '../../provider-builder/components/request-selection/select-data.component';

const BuildSelections = () => {
  const dispatch = useAppDispatch();

  return (
    <SelectData
      searchText={''}
      setActiveStepInnerForm={(e) => dispatch(updateAppActiveStep(e))}
    />
  );
};
export default BuildSelections;
